"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textMixin = exports.overflowEllipsisMixin = exports.Text = void 0;

var _v = require("@artsy/palette-tokens/dist/typography/v2");

var _v2 = require("@artsy/palette-tokens/dist/typography/v3");

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme");

var _Box = require("../Box");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var textColor = (0, _styledSystem.style)({
  prop: "textColor",
  cssProperty: "color",
  key: "colors"
});
var textTransform = (0, _styledSystem.system)({
  textTransform: true
});
/** styled functions for Text */

var textMixin = (0, _styledSystem.compose)(_styledSystem.typography, _styledSystem.color, textColor, textTransform);
/** Adds ellipsis to overflowing text */

exports.textMixin = textMixin;
var overflowEllipsisMixin = (0, _styledComponents.css)(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
/** TextProps */

exports.overflowEllipsisMixin = overflowEllipsisMixin;

/** Text */
var Text = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Text",
  componentId: "sc-18gcpao-0"
})(["&&{", " ", "}"], function (props) {
  return (0, _Theme.getThemeConfig)(props, {
    v2: (0, _styledComponents.css)(["", " ", " @media (min-width:", "){", " ", "}"], (0, _styledSystem.variant)({
      variants: _v.TEXT_VARIANTS.small
    }), textMixin, (0, _themeGet.themeGet)("breakpoints.0"), (0, _styledSystem.variant)({
      variants: _v.TEXT_VARIANTS.large
    }), textMixin),
    v3: (0, _styledComponents.css)(["", " ", ""], (0, _styledSystem.variant)({
      variants: _v2.TEXT_VARIANTS
    }), textMixin)
  });
}, function (props) {
  return (0, _styledComponents.css)(["", " ", ""], props.overflowEllipsis && overflowEllipsisMixin, props.lineClamp && (0, _styledComponents.css)(["display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";line-clamp:", ";overflow:hidden;"], props.lineClamp, props.lineClamp));
});
exports.Text = Text;
Text.displayName = "Text";
Text.defaultProps = {
  fontFamily: "sans",
  variant: "text"
};
//# sourceMappingURL=Text.js.map